/**
 *
 * @param {string} input O texto digitado pelo usuário na busca.
 * @param {object} option O objeto da opção fornecido pelo Ant Design.
 * @returns {boolean} Retorna `true` se a opção deve ser exibida, `false` caso contrário.
 */
export const jobTitleSelectFilter = (input, option) => {
  if (!option || !option.props || Array.isArray(option.props.children)) {
    return false;
  }

  const searchText = input.toLowerCase();
  const optionText = (option.props.children || '').toLowerCase();
  const groupText = (option.props.groupname || '').toLowerCase();
  return optionText.includes(searchText) || groupText.includes(searchText);
};
